export default __webpack_public_path__ + "static/Fannie-Mae-Logo-199faf22eeffed401b9381aed62b5b3b.png";